/**
 * emiiter：发射器
 * 注意事项：componentName 要在组件中声明 这是一个自定义属性，可以随意切换名字
 */

function broadcast(componentName, eventName, params) {
    this.$children.forEach(child => {
        let name = child.$options.componentName;
        name === componentName ? child.$emit.apply(child, [eventName].concat(params)) :
            borderCast.apply(child, [componentName, eventName].concat([params]))
    })
}

function dispatch(componentName, eventName, params) {
    let parent = this.$parent || this.$root,
        name = parent.$options.componentName;
    // 如果有父组件或者【没有 name 或者 name 不等于 componentName】
    while (parent && (!name || name !== componentName)) {
        console.log('====componentName===', parent)

        parent = parent.$parent;

        parent ? (name = parent.$options.componentName) : ""
    }

    parent ? (parent.$emit.apply(parent, [eventName].concat(params))) : ''
}

export default {
    dispatch,
    broadcast
}


// WEBPACK FOOTER //
// ./src/mixins/emitter.js